/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_DRAFT_APPLICATIONS } from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
import { userListConfig } from '../../config/userLists.config';
import { APPLICATION_TYPE } from '@/config/applicationType.config';
import { APPLICATION_STATUS } from '@/config/applicationStatus.config';

export interface IDraftApplicationsMethods extends IPluginMethodMap {
  getDraftApplications(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class DraftApplicationsService implements IAgentPlugin {
  readonly methods: IDraftApplicationsMethods;

  constructor() {
    this.methods = {
      getDraftApplications: this.getDraftApplicationsProps.bind(this),
    };
  }

  async getDraftApplicationsProps(args: any) {
    console.log(`getDraftApplicationsProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    console.log('roetrn-->', role);
    // const vuid = userProfile?.vuid;
    // const formDataConfig = getSrv()?.agent.getFormData();

    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    try {
      if (client) {
        const statusValue =
          whoAmI === 'prospective_employee'
            ? ['APPLICANT_DRAFT']
            : ['APPLICATION_INCOMPLETE', 'APPLICANT_DRAFT'];
        const roetable = [
          {
            column: 'type',
            op: 'In',
            value: ['CARICOM_RENEW_WORK_PERMIT', 'CARICOM_NEW_WORK_PERMIT'],
          },
        ];
        const res = await client.query(GET_DRAFT_APPLICATIONS, {
          input: {
            where: [
              ...(args?.where ?? []),
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
              {
                column: 'status',
                op: 'In',
                value: statusValue,
              },
              // trn?null:roetable
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
            limit: args?.size,
            skip: args?.offset,
          },
        });
        if (res?.data) {
          console.log(`table data2`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfApplication?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            //userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfApplication?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfApplication?.currentPage,
            pageSize: res?.data?.getListOfApplication?.pageSize,
            totalCount: res?.data?.getListOfApplication?.totalCount,
            totalPages: res?.data?.getListOfApplication?.totalPages,
          };
        } else {
          console.log('hiii', res);
          if (res?.error) {
            return {
              error: true,
              isEmpty: true,
            };
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        error: true,
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.applicationNo,
          name:
            item?.applicantInfo?.lastName || item?.applicantInfo?.firstName
              ? `${
                  item?.applicantInfo?.lastName
                    ? toHeaderCase(item?.applicantInfo?.lastName)
                    : ''
                }, ${
                  item?.applicantInfo?.firstName
                    ? toHeaderCase(item?.applicantInfo?.firstName)
                    : ''
                }`
              : '-',
          email: item?.applicantInfo?.email,
          savedOn: this.formatCreatedDate(item?.updatedAt),
          status: this.getFormattedStatus(item?.status),
          applicationId: item?.applicationNo ?? ' - ',
          applicationType: this.getFormattedType(item?.type),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }
  private getFormattedStatus(status: string) {
    if (APPLICATION_STATUS?.[status]) {
      return APPLICATION_STATUS?.[status];
    }
    return '-';
  }
}
